import { render, staticRenderFns } from "./ReorderModal.vue?vue&type=template&id=808e0aec&scoped=true"
import script from "./ReorderModal.vue?vue&type=script&lang=js"
export * from "./ReorderModal.vue?vue&type=script&lang=js"
import style0 from "./ReorderModal.vue?vue&type=style&index=0&id=808e0aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "808e0aec",
  null
  
)

export default component.exports